// Utility function to calculate the score for a given topic, supporting all question types
// Answers: array of survey answers, each with .topic and .answer
// topicId: the _id of the topic to compute the score for
export function calculateTopicScore(answers, topicId) {
  if (!Array.isArray(answers) || !topicId) return null;
  // Filter answers for the topic
  const topicAnswers = answers.filter(
    (a) => a.topic && (a.topic._id === topicId || a.topic === topicId)
  );
  if (topicAnswers.length === 0) return null;

  // Only count numeric answers > 0
  const numericAnswers = topicAnswers
    .map((a) => (typeof a.answer === 'number' ? a.answer : parseFloat(a.answer)))
    .filter((ans) => !isNaN(ans) && ans > 0);

  if (numericAnswers.length === 0) return null;

  // Average score, rounded to 1 decimal
  const avg = numericAnswers.reduce((sum, v) => sum + v, 0) / numericAnswers.length;
  return Number(avg.toFixed(1));
}
